/* eslint-disable space-infix-ops */
/* eslint-disable no-bitwise */
/* eslint-disable prefer-template */
/* eslint-disable max-len */
import React, {useState} from 'react';
import {Table} from 'semantic-ui-react';
import {Filter} from '../../../../manageOrders/components/internalCommons/TableFilters';
import '../styles.scss';

export const ColumnsHeader = ({fixedColumns, indexi, headerGroup, isTableFixed}) => {
  let acc = 0;
  const fixedClass = 'commercial-fixed-column commercial-fixed-header-color';
  return (
    <Table.Row key={indexi}>
      {headerGroup.headers.map((column, index) => {
        const fixedColumnsTable = [0, ...fixedColumns];
        const fixedColumnSize = fixedColumnsTable.length >= index ? fixedColumnsTable[index] : null;
        acc = acc + fixedColumnSize;
        if (index < fixedColumns.length && isTableFixed) {
          return (
            <Table.HeaderCell
              style={
                {
                  'left': acc,
                  'minWidth': fixedColumns[index],

                }
              }
              key={`title-${index}`}
              textAlign="center"
              className={`th-semanctic-custom ${column.headerClassName} ${fixedClass}
              ${index + 1 === fixedColumns.length && 'fixed-column-shadow'}`}
              {...column.getHeaderProps()}
            >
              {column.render('Header')}
            </Table.HeaderCell>
          );
        }
        return (
          <Table.HeaderCell
            key={`title-${index}`}
            textAlign="center"
            className={`th-semanctic-custom ${column.headerClassName}`}
            {...column.getHeaderProps()}
          >
            {column.render('Header')}
          </Table.HeaderCell>
        );
      })}
    </Table.Row>
  );
};

export const ColumnsFilter = ({fixedColumns, indexi, headerGroup, isTableFixed}) => {
  let acc = 0;
  const fixedClass = 'commercial-fixed-column commercial-fixed-header-color';
  return (
    <Table.Row key={`filter-${indexi}`} id="filters">
      {headerGroup.headers.map((column, index) => {
        const fixedColumnsTable = [0, ...fixedColumns];
        const fixedColumnSize = fixedColumnsTable.length >= index ? fixedColumnsTable[index] : null;
        acc = acc + fixedColumnSize;
        if (index < fixedColumns.length && isTableFixed) {
          return (
            <Table.HeaderCell
              style={
                {
                  'left': acc,
                  'minWidth': fixedColumns[index],

                }
              }
              key={`filter-${index}`}
              textAlign="center"
              className={`th-semanctic-custom ${column.headerClassName} ${fixedClass}
                ${index + 1 === fixedColumns.length && 'fixed-column-shadow'}`}
            >
              <Filter column={column} />
            </Table.HeaderCell>
          );
        }
        return (
          <Table.HeaderCell
            key={`filter-${index}`}
            textAlign="center"
            className={`th-semanctic-custom ${column.headerClassName}`}
            {...column.getHeaderProps()}
          >
            <Filter column={column} />
          </Table.HeaderCell>
        );
      }
      )}
    </Table.Row>
  );
};

const applyRowColor = (lineColors, i) => {
  const color = i % 2 === 0 ? lineColors[0] : lineColors[1];
  return `${color}`;
};

export const ColumnsData = ({
  fixedColumns,
  row,
  prepareRow,
  colorLineByProperty,
  lineColors,
  i,
  isTableFixed,
  isSmallCell,
  handleClickLine,
}) => {
  prepareRow(row);
  const [isHover, setIsHover] = useState(false);
  const fixedClass = 'commercial-fixed-column';
  let acc = 0;
  const isColoredRow = colorLineByProperty?.values?.includes(row.original[colorLineByProperty.key]);
  const bgColor = isColoredRow ? colorLineByProperty?.rgbColor : applyRowColor(lineColors, i);
  const lineColor = {
    'backgroundColor': bgColor,
    'color': '#000',
    'filter': `brightness(${isHover ? '90%' : '100%'})`,
  };
  
  const handleMouseEnter = () => {
    setIsHover(true);
  };

  const handleMouseLeave = () => {
    setIsHover(false);
  };

  return (
    <Table.Row
      className='pointer'
      key={i}
      style={lineColor}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {row.cells.map((cell, index) => {
        const fixedColumnsTable = [0, ...fixedColumns];
        const fixedColumnSize = fixedColumnsTable.length >= index ? fixedColumnsTable[index] : null;
        acc = acc + fixedColumnSize;
        if (index < fixedColumns.length && isTableFixed) {
          return (
            <Table.Cell
              key={index}
              style={
                {
                  'left': acc,
                  'minWidth': fixedColumns[index],
                  ...lineColor,
                }
              }
              textAlign="center"
              className={`commercial-row-stripped commercial-table-spacing ${cell.column.className} ${fixedClass}
                ${index + 1 === fixedColumns.length && 'fixed-column-shadow'}`}
              onClick={() => handleClickLine(row?.original, index, i)}
            >
              <div
                title={cell.value}
                className='commercial-fixed-cell-overflow'
              >
                {cell.render('Cell')}
              </div>
            </Table.Cell>
          );
        }
        return (
          <Table.Cell
            key={index}
            collapsing
            textAlign="center"
            className={`commercial-row-stripped ${cell.column.className} ${isSmallCell ? 'commercial-table-spacing' : ''}`}
            style={lineColor}
            onClick={() => handleClickLine(row?.original, index, i)}
          >
            {cell.render('Cell')}
          </Table.Cell>
        );
      })}
    </Table.Row>
  );
};
